import { SectionBody } from "./SectionBody";
import { SectionHeader } from "./SectionHeader";
import "./Section.css";
import React from "react";
import { useTranslation } from "react-i18next";
import { BriefJAMDTO } from "../../Business/dto/BriefJAM";

export interface SectionProps {
    idx: number;
    expanded: boolean;
    onChangeSection: (sectionIdx: number) => void;
    setSectionValidated: (sectionIdx: number, validated: boolean) => void;
    nextButtonVisible: boolean;
    nextButtonDisabled: boolean;
    briefToLoad?: BriefJAMDTO;
}

export abstract class Section<Props extends SectionProps> {
    public Name: string = "";

    public Component: React.FC<Props> = (props: Props) => {
        const { t } = useTranslation();
        return (
            <>
                <SectionHeader onChangeSection={props.onChangeSection} idx={props.idx}>
                    <b>{t(this.Name)}</b>
                </SectionHeader>
                <SectionBody expanded={props.expanded} onChangeSection={props.onChangeSection} idx={props.idx}>
                    {this.SectionBody(props)}
                </SectionBody>
            </>
        );
    }

    protected abstract SectionBody(props: SectionProps): JSX.Element;
};